var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    {
      attrs: { show: _vm.show },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c(
        "CabeceraModal",
        { attrs: { titulo: "Equipos" }, on: { cerrar: _vm.closeModal } },
        [
          _c(
            "div",
            {
              staticClass: "numero_sim",
              staticStyle: {
                "letter-spacing": "0.02em",
                "white-space": "nowrap",
                overflow: "hidden",
                "text-overflow": "ellipsis",
                "margin-top": "16px"
              }
            },
            [
              _c("div", {
                staticClass: "boton_crear",
                staticStyle: { height: "37px" }
              })
            ]
          )
        ]
      ),
      _c(
        "v-card",
        { attrs: { height: "55px", flat: "" } },
        [
          _c(
            "v-bottom-nav",
            {
              attrs: {
                value: true,
                active: _vm.pasos.informacionGeneral.step,
                absolute: "",
                color: "transparent"
              },
              on: {
                "update:active": function($event) {
                  return _vm.$set(_vm.pasos.informacionGeneral, "step", $event)
                }
              }
            },
            [
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.pasos.informacionGeneral.visible,
                      expression: "pasos.informacionGeneral.visible"
                    }
                  ],
                  attrs: {
                    color: "primary",
                    flat: "",
                    value: _vm.pasos.informacionGeneral.step
                  },
                  on: { click: _vm.handleInfoGeneral }
                },
                [
                  _c("span", [_vm._v("Detalle")]),
                  _c("v-icon", [_vm._v("info")])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showInfo,
              expression: "showInfo"
            }
          ],
          staticClass: "cardnew",
          attrs: { align: "center" }
        },
        [
          _c("br"),
          _c(
            "div",
            { staticClass: "orden_compra", attrs: { align: "center" } },
            [
              _c(
                "v-flex",
                { attrs: { md10: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "rounded-card" },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "col-md-12",
                          attrs: { "lazy-validation": "" }
                        },
                        [
                          _c(
                            "v-container",
                            { attrs: { "grid-list-md": "" } },
                            [
                              _c(
                                "v-toolbar",
                                [
                                  _c(
                                    "v-tabs",
                                    {
                                      attrs: { centered: "" },
                                      model: {
                                        value: _vm.tabs,
                                        callback: function($$v) {
                                          _vm.tabs = $$v
                                        },
                                        expression: "tabs"
                                      }
                                    },
                                    [
                                      _c("v-tabs-slider", {
                                        attrs: { color: "yellow" }
                                      }),
                                      _c("v-tab", [_vm._v("Equipo")]),
                                      _c("v-tab", [_vm._v("Activacion")])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-tabs-items",
                                {
                                  model: {
                                    value: _vm.tabs,
                                    callback: function($$v) {
                                      _vm.tabs = $$v
                                    },
                                    expression: "tabs"
                                  }
                                },
                                [
                                  _c(
                                    "v-tab-item",
                                    [
                                      _c("v-card", { attrs: { flat: "" } }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "gridcard2 rounded-card2 orden_compra2"
                                          },
                                          [
                                            _c(
                                              "FormFieldsContainer",
                                              { attrs: { titulo: "Equipo" } },
                                              [
                                                !_vm.loading
                                                  ? _c(
                                                      "v-flex",
                                                      {
                                                        attrs: {
                                                          s12: "",
                                                          sm12: "",
                                                          "my-4": "",
                                                          layout: "",
                                                          wrap: ""
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "v-autocomplete",
                                                              {
                                                                attrs: {
                                                                  label:
                                                                    "Equipo (Obligatorio)",
                                                                  "prepend-icon":
                                                                    "explore",
                                                                  items:
                                                                    _vm
                                                                      .filterApi
                                                                      .EQUIPOS,
                                                                  "item-text":
                                                                    "tipoeqname",
                                                                  "item-value":
                                                                    "tipoeqid",
                                                                  "return-object":
                                                                    "",
                                                                  required: "",
                                                                  disabled: true
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.paramApi
                                                                      .equipo,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.paramApi,
                                                                      "equipo",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "paramApi.equipo"
                                                                }
                                                              }
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Número Serie (Obligatorio)",
                                                                "prepend-icon":
                                                                  "abc",
                                                                required: "",
                                                                counter: 50,
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.paramApi
                                                                    .serienumero,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.paramApi,
                                                                    "serienumero",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "paramApi.serienumero"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Serie IMEI",
                                                                "prepend-icon":
                                                                  "abc",
                                                                required: "",
                                                                counter: 50,
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.paramApi
                                                                    .serieimei,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.paramApi,
                                                                    "serieimei",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "paramApi.serieimei"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Serie Cantidad Activa",
                                                                type: "number",
                                                                min: "0",
                                                                max: "999999",
                                                                "prepend-icon":
                                                                  "123",
                                                                required: "",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.paramApi
                                                                    .seriecant_activa,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.paramApi,
                                                                    "seriecant_activa",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "paramApi.seriecant_activa"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("DatePicker", {
                                                              attrs: {
                                                                label:
                                                                  "Fecha Recuperación Cliente",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.paramApi
                                                                    .seriebateria_fecha,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.paramApi,
                                                                    "seriebateria_fecha",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "paramApi.seriebateria_fecha"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "v-autocomplete",
                                                              {
                                                                attrs: {
                                                                  label:
                                                                    "Tipo Ubicación (Obligatorio)",
                                                                  items:
                                                                    _vm
                                                                      .filterApi
                                                                      .UBICACIONES,
                                                                  "item-text":
                                                                    "tipoubicaname",
                                                                  "item-value":
                                                                    "tipoubicaid",
                                                                  "prepend-icon":
                                                                    "pin_drop",
                                                                  required: "",
                                                                  disabled: true
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.paramApi
                                                                      .tipoubicaid,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.paramApi,
                                                                      "tipoubicaid",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "paramApi.tipoubicaid"
                                                                }
                                                              }
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Costo Unitario",
                                                                required: "",
                                                                "prepend-icon":
                                                                  "price_change",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.paramApi
                                                                    .costounitario,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.paramApi,
                                                                    "costounitario",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "paramApi.costounitario"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Costo Unitario CLP",
                                                                "prepend-icon":
                                                                  "price_change",
                                                                required: "",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.paramApi
                                                                    .costounitario_clp,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.paramApi,
                                                                    "costounitario_clp",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "paramApi.costounitario_clp"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Costo Flete OC",
                                                                "prepend-icon":
                                                                  "price_change",
                                                                required: "",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.paramApi
                                                                    .costoflete_oc,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.paramApi,
                                                                    "costoflete_oc",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "paramApi.costoflete_oc"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Nuevo Precio Unitario",
                                                                "prepend-icon":
                                                                  "price_change",
                                                                required: "",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.paramApi
                                                                    .nuevoprecio_unitario,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.paramApi,
                                                                    "nuevoprecio_unitario",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "paramApi.nuevoprecio_unitario"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Factor Importación",
                                                                "prepend-icon":
                                                                  "percent",
                                                                required: "",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.paramApi
                                                                    .factorimportacion,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.paramApi,
                                                                    "factorimportacion",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "paramApi.factorimportacion"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Nuevo Precio Unitario USD",
                                                                "prepend-icon":
                                                                  "price_change",
                                                                required: "",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.paramApi
                                                                    .nuevoprecio_unitariousd,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.paramApi,
                                                                    "nuevoprecio_unitariousd",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "paramApi.nuevoprecio_unitariousd"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-checkbox", {
                                                              attrs: {
                                                                label:
                                                                  "Desinstalado",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.paramApi
                                                                    .desinstalado,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.paramApi,
                                                                    "desinstalado",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "paramApi.desinstalado"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-tab-item",
                                    [
                                      _c("v-card", { attrs: { flat: "" } }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "gridcard2 rounded-card2 orden_compra2"
                                          },
                                          [
                                            _c(
                                              "FormFieldsContainer",
                                              { attrs: { titulo: "Equipo" } },
                                              [
                                                !_vm.loading
                                                  ? _c(
                                                      "v-flex",
                                                      {
                                                        attrs: {
                                                          s12: "",
                                                          sm12: "",
                                                          "my-4": "",
                                                          layout: "",
                                                          wrap: ""
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Número de Serie",
                                                                "prepend-icon":
                                                                  "abc",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "Número de Serie"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "Número de Serie",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "\n                                Activaciones_equipos['Número de Serie']\n                              "
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Tipo de Equipo ID",
                                                                "prepend-icon":
                                                                  "abc",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "Tipo de Equipo ID"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "Tipo de Equipo ID",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "\n                                Activaciones_equipos['Tipo de Equipo ID']\n                              "
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Número de Activación",
                                                                "prepend-icon":
                                                                  "abc",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "Número de Activación"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "Número de Activación",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "\n                                Activaciones_equipos['Número de Activación']\n                              "
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Fecha de Alta",
                                                                "prepend-icon":
                                                                  "event",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "Fecha de Alta"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "Fecha de Alta",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "Activaciones_equipos['Fecha de Alta']"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Es Arriendo",
                                                                "prepend-icon":
                                                                  "attach_money",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "Es Arriendo"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "Es Arriendo",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "Activaciones_equipos['Es Arriendo']"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "ID Dispositivo",
                                                                "prepend-icon":
                                                                  "devices_other",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "ID Dispositivo"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "ID Dispositivo",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "Activaciones_equipos['ID Dispositivo']"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label: "AVL",
                                                                "prepend-icon":
                                                                  "gps_fixed",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "AVL"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "AVL",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "Activaciones_equipos['AVL']"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Número de Serie SIM",
                                                                "prepend-icon":
                                                                  "sim_card",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "Número de Serie SIM"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "Número de Serie SIM",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "\n                                Activaciones_equipos['Número de Serie SIM']\n                              "
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Fecha de Instalación",
                                                                "prepend-icon":
                                                                  "today",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "Fecha de Instalación"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "Fecha de Instalación",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "\n                                Activaciones_equipos['Fecha de Instalación']\n                              "
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Patente Vehículo",
                                                                "prepend-icon":
                                                                  "directions_car",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "Patente Vehículo"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "Patente Vehículo",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "\n                                Activaciones_equipos['Patente Vehículo']\n                              "
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Fecha de Baja",
                                                                "prepend-icon":
                                                                  "event_busy",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "Fecha de Baja"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "Fecha de Baja",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "Activaciones_equipos['Fecha de Baja']"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Observaciones",
                                                                "prepend-icon":
                                                                  "notes",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "Observaciones"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "Observaciones",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "Activaciones_equipos['Observaciones']"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Número de Asignación",
                                                                "prepend-icon":
                                                                  "assignment",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "Número de Asignación"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "Número de Asignación",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "\n                                Activaciones_equipos['Número de Asignación']\n                              "
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Plataforma Ingresada",
                                                                "prepend-icon":
                                                                  "cloud_queue",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "Plataforma Ingresada"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "Plataforma Ingresada",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "\n                                Activaciones_equipos['Plataforma Ingresada']\n                              "
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Fecha Plataforma",
                                                                "prepend-icon":
                                                                  "event_note",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "Fecha Plataforma"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "Fecha Plataforma",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "\n                                Activaciones_equipos['Fecha Plataforma']\n                              "
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Plataforma",
                                                                "prepend-icon":
                                                                  "dashboard",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "Plataforma"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "Plataforma",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "Activaciones_equipos['Plataforma']"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label: "EPC",
                                                                "prepend-icon":
                                                                  "memory",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "EPC"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "EPC",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "Activaciones_equipos['EPC']"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Modalidad",
                                                                "prepend-icon":
                                                                  "swap_calls",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "Modalidad"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "Modalidad",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "Activaciones_equipos['Modalidad']"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "RUT Cliente",
                                                                "prepend-icon":
                                                                  "account_box",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "RUT Cliente"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "RUT Cliente",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "Activaciones_equipos['RUT Cliente']"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "ID Cliente",
                                                                "prepend-icon":
                                                                  "perm_identity",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "ID Cliente"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "ID Cliente",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "Activaciones_equipos['ID Cliente']"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "ID Flota",
                                                                "prepend-icon":
                                                                  "local_shipping",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "ID Flota"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "ID Flota",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "Activaciones_equipos['ID Flota']"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Nro. Movimiento INET",
                                                                "prepend-icon":
                                                                  "swap_horiz",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "Nro. Movimiento INET"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "Nro. Movimiento INET",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "\n                                Activaciones_equipos['Nro. Movimiento INET']\n                              "
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Flag INET OK",
                                                                "prepend-icon":
                                                                  "check_circle_outline",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "Flag INET OK"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "Flag INET OK",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "Activaciones_equipos['Flag INET OK']"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Activación Finalizada",
                                                                "prepend-icon":
                                                                  "done_all",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "Activación Finalizada"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "Activación Finalizada",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "\n                                Activaciones_equipos['Activación Finalizada']\n                              "
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Flag CRM OK",
                                                                "prepend-icon":
                                                                  "flag",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "Flag CRM OK"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "Flag CRM OK",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "Activaciones_equipos['Flag CRM OK']"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Origen Registro",
                                                                "prepend-icon":
                                                                  "source",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "Origen Registro"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "Origen Registro",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "\n                                Activaciones_equipos['Origen Registro']\n                              "
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Patente Antigua",
                                                                "prepend-icon":
                                                                  "history",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "Patente Antigua"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "Patente Antigua",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "\n                                Activaciones_equipos['Patente Antigua']\n                              "
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Desinstalado",
                                                                "prepend-icon":
                                                                  "remove_circle_outline",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "Desinstalado"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "Desinstalado",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "Activaciones_equipos['Desinstalado']"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "CRM Alta",
                                                                "prepend-icon":
                                                                  "arrow_upward",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "CRM Alta"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "CRM Alta",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "Activaciones_equipos['CRM Alta']"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Glosa CRM",
                                                                "prepend-icon":
                                                                  "comment",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "Glosa CRM"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "Glosa CRM",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "Activaciones_equipos['Glosa CRM']"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Glosa INET",
                                                                "prepend-icon":
                                                                  "comment",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "Glosa INET"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "Glosa INET",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "Activaciones_equipos['Glosa INET']"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Número Movimiento INET",
                                                                "prepend-icon":
                                                                  "shuffle",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "Número Movimiento INET"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "Número Movimiento INET",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "\n                                Activaciones_equipos['Número Movimiento INET']\n                              "
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-flex",
                                                          {
                                                            attrs: {
                                                              xs12: "",
                                                              sm4: ""
                                                            }
                                                          },
                                                          [
                                                            _c("v-text-field", {
                                                              attrs: {
                                                                label:
                                                                  "Tramo Baja",
                                                                "prepend-icon":
                                                                  "trending_down",
                                                                disabled: true
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .Activaciones_equipos[
                                                                    "Tramo Baja"
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.Activaciones_equipos,
                                                                    "Tramo Baja",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "Activaciones_equipos['Tramo Baja']"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }